import React from "react";
import { Popup, Table } from "semantic-ui-react";

const emptyField = "--:--:--";

const StatsCell = ({ min, avg, max, intl, ...props }) => {
  return (
    <Table.Cell>
      <Popup
        content={
          <div>
            <div>{intl.formatMessage({id:"title.forSelectedPeriod"})}</div>
            <div>{intl.formatMessage({id:"route.minTime"})} {min??emptyField}</div>
            <div>{intl.formatMessage({id:"route.avgTime"})} {avg??emptyField}</div>
            <div>{intl.formatMessage({id:"route.maxTime"})} {max??emptyField}</div>
          </div>
        }
        position='top center'
        inverted
        mouseEnterDelay={500}
        trigger={
          <div>
            <div>{min??emptyField}</div>
            <div>{avg??emptyField}</div>
            <div>{max??emptyField}</div>
          </div>
        }
      />
    </Table.Cell>
  );
};

export default StatsCell;
